/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoggerService } from '../../shared/services/logger.service';
import { SearchField, SearchFormModel } from '../state/search.model';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    exportAs: 'formGroup',
    selector: 'dash-gis-criteria-form',
    templateUrl: './criteria-form.component.html',
    styleUrls: ['./criteria-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatSelect,
        MatOption,
        MatInput,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepicker,
        MatButton,
    ],
})
export class CriteriaFormComponent implements OnInit {
    @Input() criteria: SearchFormModel;
    @Input() criteriaFormGroup: UntypedFormGroup;

    // public fields: SearchField[];

    constructor(private logger: LoggerService) {}

    public ngOnInit() {}

    public fillFromExample(field: SearchField, index) {
        const control = this.criteriaFormGroup.get(['fields', index, field.fieldValue.name]);
        let newValue: any = field.fieldValue.example;
        if (field.fieldValue.uitype === 'date') {
            // parse date to JS Date
            newValue = new Date(field.fieldValue.example as string);
        }
        if (field.fieldValue.type === 'numeric') {
            let testValue = parseInt(newValue, 10);
            if (testValue.toString() === newValue) {
                newValue = testValue;
            } else {
                testValue = parseFloat(newValue);
                if (testValue.toString() === newValue) {
                    newValue = testValue;
                }
            }
        }

        control.patchValue(newValue, {
            onlySelf: false,
            emitEvent: true,
        });
        this.criteriaFormGroup.updateValueAndValidity({ emitEvent: true });
    }

    public compareOpValues(a: any, b: any) {
        const valueA = a.hasOwnProperty('type') ? a.type : a;
        const valueB = b.hasOwnProperty('type') ? b.type : b;

        return valueA === valueB;
    }
}
